export default "__VITE_ASSET__BXw$l4a3__"